/** Default application SQL migrations directory (project-relative). */
export const DEFAULT_MIGRATIONS_DIRECTORY = "athena/migrations";
